import React from 'react';
import { ActivityIndicator, ActivityIndicatorProps } from 'react-native';
import { useTheme } from '@pulsar/core';

type SpinnerSize = 'xs' | 's' | 'm' | 'l';
export type SpinnerProps = Omit<ActivityIndicatorProps, 'size'> & {
  size?: SpinnerSize | number;
};

const sizeMap: {
  [key in SpinnerSize]: number;
} = {
  xs: 16,
  s: 24,
  m: 32,
  l: 44,
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 's', ...props }) => {
  const theme = useTheme();

  return (
    <ActivityIndicator
      color={theme.colors.spinner}
      size={typeof size === 'number' ? size : sizeMap[size]}
      {...props}
    />
  );
};
